import { Router } from 'react-router-dom';
import React from 'react';
import { Listener } from 'history';
import useHistory from '../hooks/useHistory';

export default function BrowserRouter({
  children,
  listeners,
}: {
  children: JSX.Element | (JSX.Element | null)[];
  listeners: Listener[];
}) {
  const history = useHistory();

  const [state, setState] = React.useState({
    action: history.action,
    location: history.location,
  });

  React.useEffect(() => {
    listeners?.map(history.listen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router action={state.action} location={state.location} navigator={history}>
      {children}
    </Router>
  );
}
